import Vue from 'vue'
import Offset from '@/components/helper/Offset'
import Card from '@/components/material/Card'
import ChartCard from '@/components/material/ChartCard'
import Notification from '@/components/material/Notification'
import StatsCard from '@/components/material/StatsCard'
import JsonExcel from "vue-json-excel"
import TableFooter from '@/components/base/TableFooter'
import StatusTag from '@/components/base/StatusTag'
import ConfirmDialog from '@/components/base/ConfirmDialog'
import FilterPanel from '@/components/base/FilterPanel'

Vue.component(Offset.name, Offset)
Vue.component(Card.name, Card)
Vue.component(ChartCard.name, ChartCard)
Vue.component(Notification.name, Notification)
Vue.component(StatsCard.name, StatsCard)
Vue.component("downloadExcel", JsonExcel)
Vue.component(TableFooter.name, TableFooter)
Vue.component(StatusTag.name, StatusTag)
Vue.component(ConfirmDialog.name, ConfirmDialog)
Vue.component(FilterPanel.name, FilterPanel)
